import i18n from 'i18n'
import palette from 'ui/src/common/theme/palette'

export enum RiskLevel {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  CRITICAL = 'critical',
  PENDING = 'pending',
}

export const RISK_LEVEL_OPTIONS = Object.values(RiskLevel)
  .map(riskLevel => ({
    value: riskLevel,
    label: i18n.t(`riskLevels.${riskLevel}`),
  }))
  .filter(option => option.value !== RiskLevel.PENDING) // Exclude PENDING from options
  .reverse() // Reverse the order to have CRITICAL first

export const RISK_LEVEL_COLORS: Record<RiskLevel, string> = {
  [RiskLevel.LOW]: palette.feedback.positive[600],
  [RiskLevel.MEDIUM]: palette.feedback.warning[400],
  [RiskLevel.HIGH]: palette.feedback.orange[500],
  [RiskLevel.CRITICAL]: palette.feedback.negative[400],
  [RiskLevel.PENDING]: palette.gray[400],
}

export const RISK_LEVEL_ORDER: Record<RiskLevel, number> = {
  [RiskLevel.CRITICAL]: 0,
  [RiskLevel.HIGH]: 1,
  [RiskLevel.MEDIUM]: 2,
  [RiskLevel.LOW]: 3,
  [RiskLevel.PENDING]: 4,
}
